export default __webpack_public_path__ + "static/media/Barbs of the Masquer of the Sands.bd46ef26.jpg";